module.exports = __webpack_public_path__ + "img/AT0000002608519.4fa2b2eb.png";